import { combineReducers } from "redux";
import {UsersRoleListReducer} from "./userroles";

const squadReducers = combineReducers({
  manageUsersData: UsersRoleListReducer,
  
});

export default squadReducers;